import { useQuery } from "@tanstack/react-query";
import chatsService from "services/admin/chatsService";

export const useGetChat = (chatID) => {
    return useQuery({
        queryKey: ['getChat', chatID],
        enabled: !!chatID,
        queryFn: async () => {
            const response = await chatsService.get(chatID);
            return response.data || [];
        },
        refetchOnWindowFocus: false,
    });
};